module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-desktop@3x-2407db9a82d5cc849d2a7eaa244e2a30.jpg";